<template>
	<v-dialog v-model="dialog" max-width="500">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2 mt-4" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-file-send-outline</v-icon>
				設計に施工法検討依頼を発行する
			</v-btn>
		</template>

		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 施工法検討依頼</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<p class="text-body-2">施工法検討依頼を発行します。<br />希望納期を入力してください</p>
				<p class="mt-4">
					<strong> 工事依頼希望納期 </strong>：
					{{ common.formatDate(requirement.deadline) }}
				</p>

				<v-menu
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="newRequirement.deadline"
							label="施工法検討依頼納期"
							class="mt-4"
							outlined
							dense
							readonly
							:rules="[rules.required]"
							v-bind="attrs"
							v-on="on"
						/>
					</template>
					<v-date-picker
						class="date-picker"
						v-model="newRequirement.deadline"
						no-title
						locale="ja-JP"
					/>
				</v-menu>
				<v-textarea label="伝達事項" v-model="newRequirement.message" class="mt-4" outlined dense />
				<div>
					<v-btn color="secondary" class="mt-2" @click="$refs.uploadFile.click()">
						<v-icon class="mr-1">mdi-paperclip-plus</v-icon>
						添付ファイルを追加する
						<input
							type="file"
							class="d-none"
							ref="uploadFile"
							@change="addFiles($event)"
							multiple
						/>
					</v-btn>
					<div class="file-area mt-2">
						<span v-if="files.length < 1" class="filename text-body-2">選択されていません</span>
						<template v-else>
							<v-chip
								class="ma-1 mt-2"
								close
								label
								outlined
								color="primary"
								@click:close="removeFile(i)"
								v-for="(file, i) in files"
								:key="file.name"
							>
								<v-icon class="mr-1">mdi-paperclip</v-icon>
								{{ file.name }}
							</v-chip>
						</template>
					</div>
				</div>
			</div>
			<v-card-actions>
				<v-row no-gutters class="my-4">
					<v-col sm="2" cols="0" />
					<v-col sm="4" cols="12" class="text-center">
						<v-btn color="secondary" @click="submitForm">
							<v-icon class="mr-1">mdi-file-send-outline</v-icon>
							上記で依頼作成
						</v-btn>
					</v-col>
					<v-col sm="4" cols="12" class="text-center">
						<v-btn @click="dialog = false"> キャンセル </v-btn>
					</v-col>
					<v-col sm="2" cols="0" />
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"

export default {
	props: {
		requirement: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			newRequirement: {
				deadline: null,
				message: null,
			},
			files: [],
			dialog: false,
			rules,
			common,
		}
	},
	methods: {
		submitForm() {
			// 見積提出処理
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/requirements`
			const params = { requirement: this.newRequirement }
			axios
				.put(url, params, { headers })
				.then((res) => {
					// TODO
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.$emit("submit-requirement")
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		removeFile(index) {
			this.files.splice(index, 1)
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.files.push(file[1])
			})
		},
	},
}
</script>
